import { MouseSetKeyType } from "../data_type/response";
import type { DeviceMapKey } from "./device";
import { OutputMode, type KIO, type KeyMap } from "../../define/define";
import { DVKFromVK } from "../../define/define_fn";
import { deviceManager } from "../../device/device_manager";
import { splitDVK, splitIntoBytes } from "../tool";
import { defaultVK } from "@hid/define/define_keys";
import { IsModifierKey, encodeCombinationKeys } from "@hid/define/define_hid";


class He3 implements DeviceMapKey {

    encodeKey(params: KIO): KeyMap {
        let setType: MouseSetKeyType = MouseSetKeyType.Keyboard;

        if (params.Output.DataIndex > -1 && params.Output.Mode == OutputMode.Macro) {
            setType = MouseSetKeyType.Macro;
            return [setType, params.Output.DataIndex, params.Output.Extension[0], params.Output.Extension[1]]
        }

        let setKey = 0;
        if (params.Output.Mode == OutputMode.Key && params.Output.VK == defaultVK) {
            return [0, 0, 0, 0]
        } else {
            setKey = DVKFromVK(params.Output.VK, deviceManager.deviceID, 'hid');
        }


        const [setmode, dvk] = splitDVK(setKey)
        if (params.Input.WithModifier && params.Input.WithModifier.length > 0) {
            return [setType, encodeCombinationKeys(params.Input.WithModifier), dvk, 0]
        }

        if (setmode == MouseSetKeyType.Mouse) {
            setType = MouseSetKeyType.Mouse;
            return [setType, 0x01, dvk, 0]
        }

        if (setmode == MouseSetKeyType.Media) {
            setType = MouseSetKeyType.Media;
            const [consumerLowByte, consumerHighByte] = splitIntoBytes(dvk)
            return [setType, consumerLowByte, consumerHighByte, 0]
        }

        if (setmode == MouseSetKeyType.Extra) {
            setType = MouseSetKeyType.Extra;
            return [setType, dvk, 0, 0]
        }

        // 设置键盘热键时调整一下顺序
        if (IsModifierKey(params.Output.VK)) {
            return [setType, setKey, 0, 0]
        }

        return [setType, 0, setKey, 0]
    }

    encodeMacroType(type: number, state: number): number {
        let byte = 0x00;
        byte |= (type & 0b111) << 4;
        byte |= (state & 0b1) << 7;
        return byte
    }

}

export const he3Data = new He3();

//0x00 : 播放一次
// 0x01 : 固定次数
// 0x02 : 再次按下结束
// 0x03 : 松开停止
// 0x04 : 点按播放
export enum he3MacorType {
    PlayOnce = 0x00,
    FixedCount = 0x01,
    PlayAgain = 0x02,
    StopByRelease = 0x03,
    PlayByClick = 0x04,
}
